// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import {
    BREAKPOINTS,
    down,
} from 'common/styles/breakpoints';

interface IIconWrapperProps {
    color?: string;
    $adaptive?: boolean;
}

export const IconWrapper = styled.span<IIconWrapperProps>`
    margin-right: 6px;
    gap: 6px;
    display: flex;
    align-items: center;
    color: ${props => props.color ? props.color : 'currentColor'};

    ${({ $adaptive }) => $adaptive && `
        ${down(BREAKPOINTS.LG)} {
            .location-name {
                display: none;
            }
        }
    `}
`;
